import styled from "styled-components";
import { LoadingIndicator } from "../LoadingIndicator";

const StyledMessagePage = styled.div`
  position: absolute;
  top: 50%;
  bottom: 50%;
  left: 0;
  right: 0;
  text-align: center;
  small {
    padding: 20px;
  }
`;

export interface MessagePageInterface {
  testid?: string;
  message: string;
  actionName: string;
}
export const MessagePage = ({
  testid,
  message,
  actionName
}: MessagePageInterface) => (
  <StyledMessagePage>
    <LoadingIndicator
      actionName={actionName}
      data-testid={testid}
      text={message}
    />
  </StyledMessagePage>
);
